import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DescuentoPorcentajeFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  values,
  setValues
}) => {
  return (
    <Form.Group>
      <Form.Label text='PORCENTAJE' htmlFor='input-descuentoPorcentaje' md={4} />
      <Col md={8}>
        <Field name='descuentoPorcentaje'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-descuentoPorcentaje'
              placeholder='0'
              onChange={e => {
                handleChange(e)
                values.descuentoPorcentaje = e.target.value
                values.descuentoMonto = ''
                setValues(values)
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DescuentoPorcentajeFormGroup)
